import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const reviews = [
    {
        name: "Sebastian R.",
        when: "3 months ago",
        text: "Exceptional service and excellent value for the price. He paid attention to every single detail — my car looks better than it ever has after a regular wash. Interior spotless, exterior shining.",
    },
    {
        name: "Luis R.",
        when: "4 months ago",
        text: "They did an incredible job cleaning my car. It looks brand new and the attention to detail is impeccable. Truly professional, high-end service from start to finish. Highly recommend if you want your vehicle flawless!",
    },
    {
        name: "Xaviar",
        when: "3 months ago",
        text: "Exceptional service, fast and efficient. I drove away satisfied with a spotless car and very reasonable prices.",
    },
];

export const Reviews = () => (
    <section id="reviews" data-testid="reviews-section" className="relative py-20 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
                <div>
                    <Reveal>
                        <p className="font-code text-xs uppercase tracking-[0.25em] text-zinc-500 mb-5">
                            Reviews
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-display font-extrabold tracking-tight text-2xl sm:text-3xl lg:text-4xl">
                            What customers <span className="text-zinc-500">say.</span>
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.2}>
                    <div data-testid="reviews-rating-badge" className="flex items-center gap-3 border border-white/10 rounded-full px-5 py-2.5 bg-[#121216]/60">
                        <span className="flex gap-0.5">
                            {[...Array(5)].map((_, i) => (
                                <Star key={i} className="w-3.5 h-3.5 fill-white text-white" />
                            ))}
                        </span>
                        <span className="font-code text-[11px] uppercase tracking-[0.2em] text-zinc-400">
                            5.0 · 9 Google reviews
                        </span>
                    </div>
                </Reveal>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
                {reviews.map((r, i) => (
                    <Reveal key={r.name} delay={0.1 + i * 0.1}>
                        <figure
                            data-testid={`review-card-${i}`}
                            className="h-full flex flex-col border border-white/10 hover:border-white/30 transition-colors duration-500 rounded-2xl p-7 bg-[#121216]/60"
                        >
                            <div className="flex gap-1 mb-5">
                                {[...Array(5)].map((_, s) => (
                                    <Star key={s} className="w-4 h-4 fill-white text-white" />
                                ))}
                            </div>
                            <blockquote className="flex-1 text-sm sm:text-base text-zinc-300 leading-relaxed">
                                "{r.text}"
                            </blockquote>
                            <figcaption className="mt-7 pt-5 border-t border-white/10 flex items-center justify-between">
                                <span className="font-display font-bold text-sm">{r.name}</span>
                                <span className="font-code text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                                    Google · {r.when}
                                </span>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
